import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import './assets/css/index.css'

createRoot(document.getElementById('root')).render(
  <App />
)
